import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

// Types
import { IContactInformationProps } from '../planSummary.types';

// Utils
import { phoneNumberTools } from '../../../../utils/tools/phoneNumberTools';

// Components
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';

// Styles
import {
    StyledDd,
    StyledDl,
    StyledDt,
    StyledSpan,
    StyledPlanSectionDataContainer,
    StyledPlanSectionHeader,
} from '../plansummary.styled';

const ContactInformation = memo(({ plan }: IContactInformationProps) => {
    const { exchangeName } = useAppSelector(environmentSelector);
    return (
        <div data-testid="contact-info">
            <StyledPlanSectionHeader>
                <h5>
                    <FormattedMessage id="plansummary.contactinformation" />
                </h5>
            </StyledPlanSectionHeader>
            <StyledPlanSectionDataContainer>
                <StyledDl>
                    <StyledDt as="dt" data-testid="customer-phone-label">
                        <StyledSpan>
                            <FormattedMessage id="plansummary.customerservice" values={{ exchangeName }} />
                        </StyledSpan>
                        <span>:</span>
                    </StyledDt>
                    <StyledDd as="dd" data-testid="customer-phone-value">
                        {phoneNumberTools.formatPhoneNumber(plan.issuerContactPhone) || (
                            <FormattedMessage id="plansummary.na" />
                        )}
                    </StyledDd>

                    <StyledDt as="dt" data-testid="customer-web-label">
                        <StyledSpan>
                            <FormattedMessage id="plansummary.web" />
                        </StyledSpan>
                        <span>:</span>
                    </StyledDt>
                    <ConditionalRendering isTrue={!!plan.issuerContactUrl}>
                        <StyledDd as="dd" data-testid="customer-web-value">
                            <a
                                href={plan.issuerContactUrl!}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-url"
                            >
                                <u>
                                    <FormattedMessage id="plansummary.clickhere" />
                                </u>
                            </a>
                        </StyledDd>
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={!plan.issuerContactUrl}>
                        <StyledDd as="dd" data-testid="customer-web-na-value">
                            <FormattedMessage id="plansummary.na" />
                        </StyledDd>
                    </ConditionalRendering>
                </StyledDl>
            </StyledPlanSectionDataContainer>
        </div>
    );
});

ContactInformation.displayName = 'ContactInformation';
export default ContactInformation;
